var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiffIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: -32.0002,
    y1: 641.8779,
    x2: -27.7514,
    y2: 637.6291,
    gradientTransform: "matrix(0.999998,0,0,-0.999998,46.703128,646.484391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,0%,0%)",
      stopOpacity: 0.101961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,0%,0%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: -31.8148,
    y1: 625.736,
    x2: -46.5178,
    y2: 622.6119,
    gradientTransform: "matrix(0.999998,0,0,-0.999998,46.703128,646.484391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,0%,0%)",
      stopOpacity: 0.101961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,0%,0%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: -48.4377,
    y1: 639.0618,
    x2: -23.4514,
    y2: 627.4131,
    gradientTransform: "matrix(0.999998,0,0,-0.999998,46.703128,646.484391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,23.529412%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 22.5 11 L 19 11 L 19 5.5 C 19 5.367188 18.945312 5.238281 18.851562 5.144531 L 13.855469 0.148438 C 13.761719 0.0546875 13.632812 0 13.5 0 L 3 0 C 1.898438 0 1 0.898438 1 2 L 1 22 C 1 23.101562 1.898438 24 3 24 L 17 24 C 18.101562 24 19 23.101562 19 22 L 19 20 L 22.5 20 C 22.777344 20 23 19.777344 23 19.5 L 23 11.5 C 23 11.222656 22.777344 11 22.5 11 Z M 22.5 11 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 14 1.707031 L 17.292969 5 L 15 5 C 14.449219 5 14 4.550781 14 4 Z M 14 1.707031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18 22 C 18 22.550781 17.550781 23 17 23 L 3 23 C 2.449219 23 2 22.550781 2 22 L 2 2 C 2 1.449219 2.449219 1 3 1 L 13 1 L 13 4 C 13 5.101562 13.898438 6 15 6 L 18 6 L 18 11 L 6.5 11 C 6.222656 11 6 11.222656 6 11.5 L 6 19.5 C 6 19.777344 6.222656 20 6.5 20 L 18 20 Z M 18 22 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.411765%,62.745098%,91.764706%)",
      fillOpacity: 1
    },
    d: "M 7 12 L 22 12 L 22 19 L 7 19 Z M 7 12 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 15 6 C 14.53125 6 14.105469 5.832031 13.761719 5.558594 L 13.75 5.558594 L 18 9.808594 L 18 6 Z M 15 6 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 6.179688 19.875 L 9.304688 23 L 17 23 C 17.550781 23 18 22.550781 18 22 L 18 20 L 6.5 20 C 6.375 20 6.265625 19.949219 6.179688 19.875 Z M 6.179688 19.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,23.529412%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 8 14 L 9 14 L 9 17.5 C 9 17.777344 9.222656 18 9.5 18 C 9.777344 18 10 17.777344 10 17.5 L 10 14 L 11 14 C 11.277344 14 11.5 13.777344 11.5 13.5 C 11.5 13.222656 11.277344 13 11 13 L 8 13 C 7.722656 13 7.5 13.222656 7.5 13.5 C 7.5 13.777344 7.722656 14 8 14 Z M 8 14 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,23.529412%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 12.5 18 C 12.777344 18 13 17.777344 13 17.5 L 13 13.5 C 13 13.222656 12.777344 13 12.5 13 C 12.222656 13 12 13.222656 12 13.5 L 12 17.5 C 12 17.777344 12.222656 18 12.5 18 Z M 12.5 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 22.5 11 L 19 11 L 19 5.5 C 19 5.367188 18.945312 5.238281 18.851562 5.144531 L 13.855469 0.148438 C 13.761719 0.0546875 13.632812 0 13.5 0 L 3 0 C 1.898438 0 1 0.898438 1 2 L 1 22 C 1 23.101562 1.898438 24 3 24 L 17 24 C 18.101562 24 19 23.101562 19 22 L 19 20 L 22.5 20 C 22.777344 20 23 19.777344 23 19.5 L 23 11.5 C 23 11.222656 22.777344 11 22.5 11 Z M 22.5 11 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,23.529412%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 14.5 18 C 14.777344 18 15 17.777344 15 17.5 L 15 16 L 16 16 C 16.277344 16 16.5 15.777344 16.5 15.5 C 16.5 15.222656 16.277344 15 16 15 L 15 15 L 15 14 L 16.5 14 C 16.777344 14 17 13.777344 17 13.5 C 17 13.222656 16.777344 13 16.5 13 L 14.5 13 C 14.222656 13 14 13.222656 14 13.5 L 14 17.5 C 14 17.777344 14.222656 18 14.5 18 Z M 14.5 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,23.529412%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 18.5 18 C 18.777344 18 19 17.777344 19 17.5 L 19 16 L 20 16 C 20.277344 16 20.5 15.777344 20.5 15.5 C 20.5 15.222656 20.277344 15 20 15 L 19 15 L 19 14 L 20.5 14 C 20.777344 14 21 13.777344 21 13.5 C 21 13.222656 20.777344 13 20.5 13 L 18.5 13 C 18.222656 13 18 13.222656 18 13.5 L 18 17.5 C 18 17.777344 18.222656 18 18.5 18 Z M 18.5 18 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiffIcon);
export default __webpack_public_path__ + "static/media/tiff-icon.d5abfaf0.svg";
export { ForwardRef as ReactComponent };